import React, { FC } from 'react';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import GenreButton from '../GenreButton';
import Link from '../Link';
import View from '../View';
import styles from './styles';

export type SelectedGenresWidgetProps = {
  activeGenre?: string;
  genres: any;
  editButtonOnPress: () => void;
  genreButtonOnPress?: (e: any) => void;
  isDefaultGenreButtonActive?: boolean;
  text: string;
  subText: string;
};

export const SelectedGenresWidgetProps: FC<SelectedGenresWidgetProps> = (
  props,
) => {
  const {
    activeGenre,
    genres,
    editButtonOnPress,
    genreButtonOnPress,
    isDefaultGenreButtonActive,
    text,
    subText,
  } = props;
  const setIsActive = (genre) => {
    let isActive = isDefaultGenreButtonActive;
    if (!isDefaultGenreButtonActive && activeGenre) {
      isActive = genre === activeGenre;
    }
    return isActive;
  };

  return (
    <View accessibilityLabel="checkbox-group">
      <View style={styles.myGenresContainer}>
        <View>
          <GalanoGrotesqueText style={styles.genreText}>
            {text}
          </GalanoGrotesqueText>
          <GalanoGrotesqueText style={styles.genreSubText}>
            {subText}
          </GalanoGrotesqueText>
        </View>
        {/* TODO: Uncomment after private beta: https://app.shortcut.com/tone-birds/story/471/remove-genre-restriction-for-fans-after-private-beta */}
        {/* <View style={styles.editLinkContainer}>
          <Link
            onPress={editButtonOnPress}
            text="Edit"
            textStyle={styles.editLinkText}
          />
        </View> */}
      </View>
      <View style={styles.genreButtons}>
        {genres.length > 0 &&
          genres.map((genre) => {
            return (
              <GenreButton
                key={genre.id}
                genreObj={genre}
                isActive={setIsActive(genre.id)}
                onPress={genreButtonOnPress}
                minSelectedThreshold={false}
              />
            );
          })}
      </View>
    </View>
  );
};

export default SelectedGenresWidgetProps;
